import { Table } from '@/ui/Table';
import { Skeleton } from '@/ui/Skeleton';

export const JourneyInsightsTabsLearningItemsTableLoadingState = (): React.ReactElement => (
  <Table>
    <Table.Header>
      <Table.HeaderCell expand>
        <Skeleton height={16} width={57} />
      </Table.HeaderCell>
      {[...Array(4).keys()].map((j) => (
        <Table.HeaderCell key={j}>
          <div style={{ width: 150 }}>
            <Skeleton height={16} width={57} />
          </div>
        </Table.HeaderCell>
      ))}
      <Table.HeaderCell shrink>
        <Skeleton height={16} width={57} />
      </Table.HeaderCell>
    </Table.Header>

    <Table.Body>
      {[...Array(5).keys()].map((index) => (
        <Table.Row key={index}>
          {[...Array(6).keys()].map((index) => (
            <Table.Cell key={index}>
              <Skeleton height={16} width={57} />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);
